import React from "react";
import { GetStaticProps } from "next";
import { MetaDataPage, MetaDataPageType } from "src/models/meta/getMetaData";
import MetaContainer from "src/components/common/Layout/components/MetaContainer/MetaContainer";
import BlogPage from "src/components/BlogPage/BlogPage";
import { requestBlogPage } from "src/utils/helpers/requestApi/serverFetchPage/requestBlogPage";
import { SpecialArticleItemSchema } from "src/models/articles/getSpecialArticle";
import { LastArticlesSchema } from "src/models/articles/getLastArticles";

interface BlogProps {
  commonArticlesData: SpecialArticleItemSchema[];
  articlesData: LastArticlesSchema;
}

const Blog: React.FC<MetaDataPage & BlogProps> = ({
  metaData,
  commonArticlesData,
  articlesData,
}) => (
  <MetaContainer {...metaData}>
    <BlogPage
      commonArticlesData={commonArticlesData}
      lastArticlesData={articlesData}
      pageTitle={metaData.h1}
    />
  </MetaContainer>
);

export const getStaticProps: GetStaticProps = requestBlogPage.bind(
  null,
  MetaDataPageType.blog,
  true
);

export default Blog;
